module.exports = __webpack_public_path__ + "static/media/quickswap-quick-seeklogo.com.aedc98fd.pdf";